import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.ACCOMMODATION_SERVER_PREFIX}/refund-payment`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    getRefundByApplicationId: (applicationId: any) =>
        `${RESOURCE_ENDPOINT}/refund-list-by-application-id/${applicationId}`,
    getByWhere: () => `${RESOURCE_ENDPOINT}/getByWhere`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    getApplicationForRefund: (id: any) =>
        `${RESOURCE_ENDPOINT}/getApplicationForRefund/${id}`,
    getPaymentsByApplicationId: (applicationID: any) =>
        `${RESOURCE_ENDPOINT}/getPaymentsByApplicationId/${applicationID}`,
    getSelectedApplication: (applicationID: any) =>
        `${RESOURCE_ENDPOINT}/getSelectedApplication/${applicationID}`,
};

export default class RefundPaymentApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    };

    public getRefundByApplicationId = (
        applicationId: any
    ): AxiosPromise<any> => {
        const url = endpoints.getRefundByApplicationId(applicationId);
        return HttpService.get(url);
    };

    public getByWhere = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getByWhere();
        return HttpService.get(url, params, headers);
    };

    public create = (
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    };

    public update = (
        id: any,
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (
        id: any,
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    };

    public bulk = (
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    };

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    };

    public getApplicationForRefund = (id: any): AxiosPromise<any> => {
        const url = endpoints.getApplicationForRefund(id);
        return HttpService.get(url);
    };

    public getPaymentsByApplicationId = (
        applicationId: any
    ): AxiosPromise<any> => {
        const url = endpoints.getPaymentsByApplicationId(applicationId);
        return HttpService.get(url);
    };

    public getSelectedApplication = (applicationId: any): AxiosPromise<any> => {
        const url = endpoints.getSelectedApplication(applicationId);
        return HttpService.get(url);
    };
}
